import type { SearchState } from './types';

export const INITIAL_SEARCH: SearchState = {
  search_yearmonth: '',
  massager_id: '',
  search_visitmonth: '',
  rezept_template_id: '',
  rezept_kbn: '',
  search_radio: 3,
  insurer_name: '',
  serial_number: '',
  insurer_type_id: '',
  ini: '',
  patient_name: '',
  sort_radio: 1,
};

export const REZEPT_KBN_OPTIONS = [
  { value: '', label: 'すべて' },
  { value: '1', label: '本' },
  { value: '2', label: '関' },
] as const;

export const SEARCH_RADIO_OPTIONS = [
  { value: 1, label: '保険者名' },
  { value: 2, label: '受診者番号' },
  { value: 3, label: '保険者種別' },
  { value: 4, label: '受診者名' },
] as const;

export const SORT_RADIO_OPTIONS = [
  { value: 1, label: '受診者番号' },
  { value: 2, label: '仮名' },
  { value: 3, label: '保険者番号' },
] as const;

/** Controls disabled state per active search_radio value (mirrors RA2 distargetobj). */
export const SEARCH_RADIO_DISABLED_MAP: Record<1 | 2 | 3 | 4, Set<keyof SearchState>> = {
  1: new Set(['ini', 'serial_number', 'insurer_type_id', 'patient_name']),
  2: new Set(['ini', 'insurer_name', 'insurer_type_id', 'patient_name']),
  3: new Set(['insurer_name', 'serial_number', 'patient_name']),
  4: new Set(['ini', 'insurer_name', 'insurer_type_id', 'serial_number']),
};

/** Fields cleared when radio flips to each value (same set as disabled map). */
export const SEARCH_RADIO_CLEAR_MAP = SEARCH_RADIO_DISABLED_MAP;

export const TABLE_SCROLL_Y = 500;

export const NOT_IMPLEMENTED_MESSAGE = 'この機能は未実装です。';
